// extracted by mini-css-extract-plugin
export default {"title":"a90468b414","bld":"_7c7e9f0d90"};